const productsAndSessionsBehaviorIds = {
    CanExcludeFromPF: 'CanExcludeFromPF',
    CanExcludeFromDiscounts: 'CanExcludeFromDiscounts',
    CanSetClosingDayBilling: 'CanSetClosingDayBilling',
    CanSetBillOnChildSick: 'CanSetBillOnChildSick',
    CanSetBillOnChildAbsent: 'CanSetBillOnChildAbsent',
    ShowWeekend: 'ShowWeekend',
    CanUseVolumePricing: 'CanUseVolumePricing',
    CanUsePackages: 'CanUsePackages',
    CanUnscheduleVersion: 'CanUnscheduleVersion',
    hasActiveSessionBillingSchemesV1: 'ActiveSessionBillingSchemesV1',
};

export default productsAndSessionsBehaviorIds;
